<div class="card">
    <div class="card-body">
        <h5 class="card-title">{{ 'export.tasks.cardTitle' | transloco }}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ 'export.selectExportTypeBelow' | transloco }}</h6>

        <hr />

        @if (permService.permissions.HasTaskAccess) {
            <button class="btn btn-default me-2 mb-2" (click)="exportTasks()">{{ 'export.tasks.tasksButton' | transloco }}</button>
        }
    </div>
</div>
